export type LoginFormInput = {
  email: string;
  password: string;
};

export type LoginPayload =
  | {
      ok: true;
      data: LoginFormInput;
    }
  | {
      ok: false;
      error: string;
    };

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function buildLoginPayload(input: LoginFormInput): LoginPayload {
  const email = input.email.trim().toLowerCase();
  const password = input.password.trim();

  if (!emailPattern.test(email)) {
    return {
      ok: false,
      error: "Please enter a valid email address.",
    };
  }

  if (!password) {
    return {
      ok: false,
      error: "Please enter your password.",
    };
  }

  return {
    ok: true,
    data: {
      email,
      password,
    },
  };
}
